import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckOpenCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M70.1693 16.7497C69.2278 15.8066 67.7002 15.805 66.7587 16.7457L37.8221 45.606L27.3818 34.2668C26.4797 33.2876 24.9545 33.2241 23.9736 34.1261C22.9935 35.0282 22.9307 36.5542 23.8328 37.5343L35.9736 50.7195C36.4182 51.2027 37.0405 51.4833 37.6966 51.497C37.7142 51.4977 37.7312 51.4977 37.7481 51.4977C38.3857 51.4977 38.9991 51.2445 39.451 50.7942L70.1646 20.1611C71.1085 19.2205 71.1101 17.6928 70.1693 16.7497Z",
		fill: "#047857"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M69.5879 37.5879C68.2556 37.5879 67.1759 38.6676 67.1759 40C67.1759 54.9854 54.9854 67.1759 40 67.1759C25.0155 67.1759 12.8241 54.9854 12.8241 40C12.8241 25.0155 25.0155 12.8241 40 12.8241C41.3322 12.8241 42.4121 11.7444 42.4121 10.4121C42.4121 9.07975 41.3322 8 40 8C22.355 8 8 22.355 8 40C8 57.6442 22.355 72 40 72C57.6442 72 72 57.6442 72 40C72 38.6677 70.9202 37.5879 69.5879 37.5879Z",
		fill: "#047857"
	})]
});
export default SvgCheckOpenCircle;
